module.exports = __webpack_public_path__ + "assets/img/egg_tart.8f9a32f8.png";